/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelUnpostedWireOrderLookup.ts       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/unposted-wire-order-lookup";

export class AutogenModelUnpostedWireOrderLookup<RowType extends ModelRow> extends Endpoint<RowType, RowUnpostedWireOrderLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowUnpostedWireOrderLookup extends ModelRow<RowUnpostedWireOrderLookupFields> {
	constructor(values?: Partial<RowUnpostedWireOrderLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowUnpostedWireOrderLookupFields {
	additional_customer_tag: string;
	additional_global_tag: string;
	authorized: string;
	average_broker_rating: number;
	booking_no: string;
	br_details_link: string;
	br_status_link: string;
	br_track_interval: number;
	br_track_status: string;
	br_track_status_desc: string;
	br_track_vehicle_id: string;
	br_tracking_id: string;
	br_vendor: string;
	broker_avail_tract: string;
	brokerage: string;
	brokerage_status: string;
	buy_to_market_ex: string;
	carrier_contact: string;
	carrier_email: string;
	carrier_empty_from_city_id: number;
	carrier_fuel_pay_rate_id: number;
	carrier_lane_rate_id: string;
	carrier_override_carrier: string;
	carrier_override_user: string;
	carrier_phone: string;
	carrier_rate_id: number;
	carrier_scorecard_export_dt: Date;
	carrier_scorecard_exported: string;
	carrier_tractor: string;
	carrier_trailer: string;
	carrier_trailer_type: string;
	chassis: string;
	checkcall_sched_id: string;
	company_id: string;
	container: string;
	container_returned: string;
	container_status: string;
	controlling_carrier_code: string;
	dedicated_order_id: string;
	dest_stop_id: string;
	dfm_user: string;
	digital_booking: string;
	dispatcher_user_id: string;
	"driver.ace_id": string;
	"driver.address": string;
	"driver.alert": string;
	"driver.allow_trailer_drop": string;
	"driver.avl_as_of_date": Date;
	"driver.avl_drive_hours": number;
	"driver.avl_hours": number;
	"driver.avl_onduty_hours": number;
	"driver.base_term1": string;
	"driver.base_term2": string;
	"driver.base_zip1": string;
	"driver.base_zip2": string;
	"driver.birth_date": Date;
	"driver.bseg": string;
	"driver.can_rehire": string;
	"driver.capcreat_filter": string;
	"driver.cb": string;
	"driver.cell_phone": string;
	"driver.chain_pref_1": string;
	"driver.chain_pref_1_value": number;
	"driver.chain_pref_2": string;
	"driver.chain_pref_2_value": number;
	"driver.choice_allocation": string;
	"driver.choice_commodity": string;
	"driver.choice_commodity_exclude": string;
	"driver.choice_customer": string;
	"driver.choice_equip_type": string;
	"driver.choice_exclude_hazmat": string;
	"driver.choice_order_type": string;
	"driver.choice_priority1": string;
	"driver.choice_priority1_value": number;
	"driver.choice_priority2": string;
	"driver.choice_priority2_value": number;
	"driver.choice_revenue": string;
	"driver.choice_review_dt": Date;
	"driver.citizen": string;
	"driver.citizen_country": string;
	"driver.city": string;
	"driver.city_id": number;
	"driver.cmove": string;
	"driver.company_id": string;
	"driver.country_hos_rules": string;
	"driver.country_id": string;
	"driver.currenteqpgrpid": string;
	"driver.ded_rqmt_type": string;
	"driver.ded_type": string;
	"driver.disable_driver_choice": string;
	"driver.disable_feasibility": string;
	"driver.disable_remote_access": string;
	"driver.doubles_certified": string;
	"driver.dri_uid": number;
	"driver.drvr_class": string;
	"driver.ds_model_flag": string;
	"driver.eld_exempt_reason_id": string;
	"driver.email": string;
	"driver.emrg_response_date": Date;
	"driver.enable_driver_app": string;
	"driver.enable_load_choice": string;
	"driver.end_status_date": Date;
	"driver.enginedata_pwd": string;
	"driver.equipment_type_id": string;
	"driver.event_date": Date;
	"driver.event_status": string;
	"driver.exclude_allocation": string;
	"driver.exclude_commodity": string;
	"driver.exclude_customer": string;
	"driver.exclude_equip_type": string;
	"driver.exclude_feasibility": string;
	"driver.exclude_order_type": string;
	"driver.exclude_revenue": string;
	"driver.experience": string;
	"driver.first_name": string;
	"driver.fleet_manager": string;
	"driver.fmcsa_clearinghouse_date": Date;
	"driver.group_id": string;
	"driver.hazmat_certified": string;
	"driver.hazmat_date": Date;
	"driver.hire_date": Date;
	"driver.hm126c_date": Date;
	"driver.home_duration": number;
	"driver.home_location_id": string;
	"driver.id": string;
	"driver.is_active": string;
	"driver.last_34_hour_start_date": Date;
	"driver.last_break_date": Date;
	"driver.last_home_date": Date;
	"driver.last_review_date": Date;
	"driver.latitude": number;
	"driver.license_country": string;
	"driver.license_date": Date;
	"driver.license_no": string;
	"driver.license_state": string;
	"driver.logbook_required": string;
	"driver.longitude": number;
	"driver.manual_pta_update": string;
	"driver.maryland_perm_date": Date;
	"driver.max_dispatches": number;
	"driver.max_dist_loc1": number;
	"driver.max_dist_loc2": number;
	"driver.max_mi_per_day": number;
	"driver.mc_login": string;
	"driver.mc_unit_password": string;
	"driver.medical_cert_exempt": string;
	"driver.medical_cert_expire": Date;
	"driver.model_flag": string;
	"driver.mpw_driver_contact_method": string;
	"driver.mpw_driver_high": number;
	"driver.mpw_driver_low": number;
	"driver.mpw_exclude": string;
	"driver.mpw_last_contact": Date;
	"driver.mpw_num_attempts": number;
	"driver.mpw_num_orders": number;
	"driver.mvr_date": Date;
	"driver.name": string;
	"driver.name_mid_initial": string;
	"driver.name_of_spouse": string;
	"driver.next_home_date": Date;
	"driver.num_complaints": number;
	"driver.pager": string;
	"driver.passport": string;
	"driver.payee_id": string;
	"driver.personal_conveyance": string;
	"driver.phone": string;
	"driver.physical_date": Date;
	"driver.planning_comment": string;
	"driver.preferred_days_out": number;
	"driver.prev_code": string;
	"driver.primary_agency": string;
	"driver.proximity_card": string;
	"driver.pta_date": Date;
	"driver.race": string;
	"driver.reason_for_leaving": string;
	"driver.record_pta": string;
	"driver.remark": string;
	"driver.reporting_status": string;
	"driver.return_home_flag": string;
	"driver.route_through_term": string;
	"driver.safety_meet_date": Date;
	"driver.safety_topic": string;
	"driver.security_date": Date;
	"driver.sex": string;
	"driver.shuttle_capable": string;
	"driver.site_id": string;
	"driver.social_security_no": string;
	"driver.speed": number;
	"driver.start_status_date": Date;
	"driver.state": string;
	"driver.status_code": string;
	"driver.stop_pta_update": string;
	"driver.tanks_endorsement": string;
	"driver.team_status": string;
	"driver.tenstreet_id": string;
	"driver.termination_date": Date;
	"driver.tractor_id": string;
	"driver.trainee": string;
	"driver.type_of": string;
	"driver.violation_comment": string;
	"driver.yard_move": string;
	"driver.zip": string;
	eform_rate_confirmation: string;
	empty2next_order: string;
	"equipment_group.company_id": string;
	"equipment_group.currentmovement_id": string;
	"equipment_group.id": string;
	equipment_group_id: string;
	"equipment_item.company_id": string;
	"equipment_item.equipment_group_id": string;
	"equipment_item.equipment_id": string;
	"equipment_item.equipment_type_id": string;
	"equipment_item.id": string;
	"equipment_item.trailer_dropped": string;
	"equipment_item.type_sequence": number;
	est_tolls: number;
	est_tolls_c: string;
	est_tolls_d: Date;
	est_tolls_n: number;
	est_tolls_r: number;
	exclude_movement: string;
	fleet_manager: string;
	freight_matching_override: string;
	fuel_distance: number;
	fuel_distance_um: string;
	fuel_tax_exempt: string;
	geo_override_mins: number;
	has_load_lock_alert: string;
	hubtran_approved_inv_date: Date;
	hubtran_ok2pay_date: Date;
	ic_company_to: string;
	ic_order_to: string;
	id: string;
	integrated_carrier_search: string;
	invitation_date: Date;
	invoice_recv_date: Date;
	is_container: string;
	is_dfm_tracking: string;
	is_dray: string;
	is_intercompany: string;
	is_local_mile: string;
	linked_id: number;
	linked_sequence: number;
	load_booking_eligible: string;
	load_booking_source: string;
	loaded: string;
	locked_user_id: string;
	ltl: string;
	ltl_staging_wrs_uid: number;
	macropoint_status: string;
	manifest_empty_distance: number;
	manifest_estimated_arrival: Date;
	manifest_estimated_depart: Date;
	manifest_hold: string;
	manifest_id: string;
	manifest_loaded_distance: number;
	manifest_reg_uid: number;
	manifest_spots_capacity: number;
	manifest_spots_consumed: number;
	manifest_weight_capacity: number;
	manifest_weight_consumed: number;
	max_buy: number;
	max_buy_c: string;
	max_buy_d: Date;
	max_buy_n: number;
	max_buy_r: number;
	max_pay_method: string;
	max_pay_units: number;
	missed_call_sent: string;
	move_distance: number;
	move_distance_um: string;
	"movement_order.company_id": string;
	"movement_order.id": string;
	"movement_order.movement_id": string;
	"movement_order.on_at_move_dest": string;
	"movement_order.on_at_move_origin": string;
	"movement_order.order_id": string;
	"movement_order.planned_manifest_id": string;
	"movement_order.sequence": number;
	movement_type: string;
	must_respond_by: Date;
	next_sched_call: Date;
	operational_status: string;
	operations_user: string;
	"orders.actual_reefer_profile": string;
	"orders.agency_id": string;
	"orders.agent_payee_id": string;
	"orders.all_vendors_enabled": string;
	"orders.allow_relay": string;
	"orders.autorate_status": string;
	"orders.bill_date": Date;
	"orders.bill_distance": number;
	"orders.bill_distance_um": string;
	"orders.billing_empty_distance": number;
	"orders.billing_empty_distance_um": string;
	"orders.billing_loaded_distance": number;
	"orders.billing_loaded_distance_um": string;
	"orders.billing_user_id": string;
	"orders.blnum": string;
	"orders.bol_note": string;
	"orders.bol_received": string;
	"orders.bol_recv_date": Date;
	"orders.booking_no": string;
	"orders.booking_number": string;
	"orders.brk_qual_profile": string;
	"orders.broker_location_id": string;
	"orders.brokerage_workflow_id": string;
	"orders.carrier_scorecard_export_dt": Date;
	"orders.carrier_scorecard_exported": string;
	"orders.cbp_crossing_date": Date;
	"orders.cbp_crossing_location_id": string;
	"orders.cbp_crossing_reason": string;
	"orders.cbsa_crossing_date": Date;
	"orders.cbsa_crossing_location_id": string;
	"orders.cbsa_crossing_reason": string;
	"orders.cc_fuel_revenue": number;
	"orders.cc_fuel_revenue_c": string;
	"orders.cc_fuel_revenue_d": Date;
	"orders.cc_fuel_revenue_n": number;
	"orders.cc_fuel_revenue_r": number;
	"orders.cc_net_revenue": number;
	"orders.cc_net_revenue_c": string;
	"orders.cc_net_revenue_d": Date;
	"orders.cc_net_revenue_n": number;
	"orders.cc_net_revenue_r": number;
	"orders.cc_pro_nbr": string;
	"orders.cobroker_location_id": string;
	"orders.collection_method": string;
	"orders.com_setpnt_temp": number;
	"orders.com_setpnt_temp_dt": Date;
	"orders.com_setpnt_temp_um": string;
	"orders.commitment_id": string;
	"orders.commodity": string;
	"orders.commodity_id": string;
	"orders.company_id": string;
	"orders.consignee_refno": string;
	"orders.consignee_stop_id": string;
	"orders.container": string;
	"orders.container_planned": string;
	"orders.container_type_id": string;
	"orders.controlling_carrier_code": string;
	"orders.copy_from_company": string;
	"orders.copy_from_order_id": string;
	"orders.copy_to_company": string;
	"orders.copy_to_order_id": string;
	"orders.ctrl_party_id": string;
	"orders.cube": number;
	"orders.curr_movement_id": string;
	"orders.cust_order_no": string;
	"orders.customer_id": string;
	"orders.dat_loadboard_refid": string;
	"orders.declared_val": number;
	"orders.def_move_type": string;
	"orders.default_match_id": string;
	"orders.dim_height": string;
	"orders.dim_length": string;
	"orders.dim_surcharge": number;
	"orders.dim_surcharge_c": string;
	"orders.dim_surcharge_d": Date;
	"orders.dim_surcharge_n": number;
	"orders.dim_surcharge_r": number;
	"orders.dim_width": string;
	"orders.dispatch_opt": string;
	"orders.dl_team_reqd": string;
	"orders.dray_del_date": Date;
	"orders.dray_del_pay": number;
	"orders.dray_del_pay_c": string;
	"orders.dray_del_pay_d": Date;
	"orders.dray_del_pay_n": number;
	"orders.dray_del_pay_r": number;
	"orders.dray_del_payee": string;
	"orders.dray_del_xfer_dt": Date;
	"orders.dray_pu_date": Date;
	"orders.dray_pu_pay": number;
	"orders.dray_pu_pay_c": string;
	"orders.dray_pu_pay_d": Date;
	"orders.dray_pu_pay_n": number;
	"orders.dray_pu_pay_r": number;
	"orders.dray_pu_payee": string;
	"orders.dray_pu_xfer_dt": Date;
	"orders.eir1_no": string;
	"orders.eir2_no": string;
	"orders.entered_user_id": string;
	"orders.equipment_type_id": string;
	"orders.equipment_type_options": string;
	"orders.est_tolls": number;
	"orders.est_tolls_c": string;
	"orders.est_tolls_d": Date;
	"orders.est_tolls_n": number;
	"orders.est_tolls_r": number;
	"orders.excise_disable_update": string;
	"orders.excise_taxable": string;
	"orders.excisetax_total": number;
	"orders.excisetax_total_c": string;
	"orders.excisetax_total_d": Date;
	"orders.excisetax_total_n": number;
	"orders.excisetax_total_r": number;
	"orders.external_invoiceno": string;
	"orders.extra_deliveries": number;
	"orders.extra_pickups": number;
	"orders.floor_loaded_freight": string;
	"orders.force_assign": string;
	"orders.forwd_location_id": string;
	"orders.free_days": number;
	"orders.freight_charge": number;
	"orders.freight_charge_c": string;
	"orders.freight_charge_d": Date;
	"orders.freight_charge_n": number;
	"orders.freight_charge_r": number;
	"orders.hazmat": string;
	"orders.hazmat_code": string;
	"orders.high_value": string;
	"orders.hold_reason": string;
	"orders.ic_company_from": string;
	"orders.ic_movement_from": string;
	"orders.ic_order_from": string;
	"orders.id": string;
	"orders.image_is_present": string;
	"orders.import_export": string;
	"orders.include_split_point": string;
	"orders.intelliset": string;
	"orders.invoice_recv_date": Date;
	"orders.is_auto_tonu": string;
	"orders.is_autorate_dist": string;
	"orders.is_container": string;
	"orders.is_dedicated": string;
	"orders.is_intercompany": string;
	"orders.is_local_mile": string;
	"orders.is_requested": string;
	"orders.is_tonu": string;
	"orders.jag_carrier_id": string;
	"orders.jag_cost_rate_id": number;
	"orders.ldport_location_id": string;
	"orders.linear_feet_avail": number;
	"orders.load_date": Date;
	"orders.loadboard": string;
	"orders.loadboard_last_refresh": Date;
	"orders.loadboard_post_movement_id": string;
	"orders.loadboard_posting_cancelled": string;
	"orders.lock_miles": string;
	"orders.ltl": string;
	"orders.markup_flat": number;
	"orders.markup_flat_c": string;
	"orders.markup_flat_d": Date;
	"orders.markup_flat_n": number;
	"orders.markup_flat_r": number;
	"orders.markup_percent": number;
	"orders.master_order_id": string;
	"orders.master_sequence": number;
	"orders.next_rebill": string;
	"orders.nte_lp_num": string;
	"orders.nte_lp_qual": string;
	"orders.on_hold": string;
	"orders.operational_status": string;
	"orders.operations_user": string;
	"orders.optimize": string;
	"orders.optiset": string;
	"orders.order_length": number;
	"orders.order_mode": string;
	"orders.order_type_id": string;
	"orders.order_value": number;
	"orders.order_value_c": string;
	"orders.order_value_d": Date;
	"orders.order_value_n": number;
	"orders.order_value_r": number;
	"orders.ordered_by": string;
	"orders.ordered_by_id": string;
	"orders.ordered_date": Date;
	"orders.ordered_method": string;
	"orders.orig_dest_rate_id": string;
	"orders.otherchargetotal": number;
	"orders.otherchargetotal_c": string;
	"orders.otherchargetotal_d": Date;
	"orders.otherchargetotal_n": number;
	"orders.otherchargetotal_r": number;
	"orders.override_arrive_early": Date;
	"orders.override_arrive_late": Date;
	"orders.override_posting_city_id": number;
	"orders.pallets_how_many": number;
	"orders.pallets_required": string;
	"orders.pay_gross": number;
	"orders.pay_gross_c": string;
	"orders.pay_gross_d": Date;
	"orders.pay_gross_n": number;
	"orders.pay_gross_r": number;
	"orders.pick_up_no": string;
	"orders.pieces": number;
	"orders.placard_required": string;
	"orders.planning_comment": string;
	"orders.pnn_callback": string;
	"orders.pnn_comment": string;
	"orders.pnn_comment2": string;
	"orders.pnn_loadboard_user_id": string;
	"orders.pnn_post_type": string;
	"orders.pnn_rate": number;
	"orders.pnn_rate_type": string;
	"orders.pnn_trailer_length": number;
	"orders.pnn_trailer_width": number;
	"orders.ponum": string;
	"orders.port": string;
	"orders.port_of_discharge": string;
	"orders.preferred_vendors": string;
	"orders.preload_trailer_id": string;
	"orders.preloaded": string;
	"orders.rate": number;
	"orders.rate_currency_type": string;
	"orders.rate_id": number;
	"orders.rate_min_weight": number;
	"orders.rate_min_weight_um": string;
	"orders.rate_source": string;
	"orders.rate_type": string;
	"orders.rate_unit_desc": string;
	"orders.rate_units": number;
	"orders.ready_to_bill": string;
	"orders.recurring_order_id": string;
	"orders.reply_transmitted": string;
	"orders.requesting_company": string;
	"orders.return_temp": number;
	"orders.return_temp_dt": Date;
	"orders.return_temp_um": string;
	"orders.return_temp_var": number;
	"orders.return_temp_var_um": string;
	"orders.revenue_code_id": string;
	"orders.revenue_share_method": string;
	"orders.round_trip": string;
	"orders.sail_date": Date;
	"orders.seal_number": string;
	"orders.seg_alloc_code": string;
	"orders.setpoint_temp": number;
	"orders.setpoint_temp_um": string;
	"orders.setpoint_var": number;
	"orders.setpoint_var_um": string;
	"orders.ship_status_to_edi": string;
	"orders.shipment_id": string;
	"orders.shipper_stop_id": string;
	"orders.shipstatus2edi_dt": Date;
	"orders.ss_location_id": string;
	"orders.status": string;
	"orders.subject_order_number": string;
	"orders.subject_order_status": string;
	"orders.subject_order_void_date": Date;
	"orders.swap": string;
	"orders.teams_required": string;
	"orders.temperature_max": number;
	"orders.temperature_max_um": string;
	"orders.temperature_min": number;
	"orders.temperature_min_um": string;
	"orders.temperature_um": string;
	"orders.total_charge": number;
	"orders.total_charge_c": string;
	"orders.total_charge_d": Date;
	"orders.total_charge_n": number;
	"orders.total_charge_r": number;
	"orders.totalcharge_and_excisetax": number;
	"orders.totalcharge_and_excisetax_c": string;
	"orders.totalcharge_and_excisetax_d": Date;
	"orders.totalcharge_and_excisetax_n": number;
	"orders.totalcharge_and_excisetax_r": number;
	"orders.tractor_type": string;
	"orders.vessel": string;
	"orders.vessel_cutoff_date": Date;
	"orders.voided_load_transmitted": string;
	"orders.voided_load_transmitted_dt": Date;
	"orders.weight": number;
	"orders.weight_um": string;
	"orders.xferred2billing": string;
	"orders.xferred2billing_dt": Date;
	origin_stop_id: string;
	override_crny_type: string;
	override_driver2_id: number;
	override_driver2_nm: string;
	override_driver_id: number;
	override_driver_nm: string;
	override_drvr2_cell: string;
	override_drvr2_country_code: string;
	override_drvr2_email: string;
	override_drvr_cell: string;
	override_drvr_country_code: string;
	override_drvr_email: string;
	override_max_pay: number;
	override_max_pay_c: string;
	override_max_pay_d: Date;
	override_max_pay_n: number;
	override_max_pay_r: number;
	override_pay_amt: number;
	override_pay_amt_c: string;
	override_pay_amt_d: Date;
	override_pay_amt_n: number;
	override_pay_amt_r: number;
	override_pay_rate: number;
	override_paye_rate: number;
	override_payee_id: string;
	override_targetpay: number;
	override_targetpay_c: string;
	override_targetpay_d: Date;
	override_targetpay_n: number;
	override_targetpay_r: number;
	override_type: string;
	override_unit_desc: string;
	override_units: number;
	pay_distance: number;
	pay_distance_um: string;
	"payee.ach_batch_class_code": string;
	"payee.add_fed_to_wh": number;
	"payee.add_fed_to_wh_c": string;
	"payee.add_fed_to_wh_d": Date;
	"payee.add_fed_to_wh_n": number;
	"payee.add_fed_to_wh_r": number;
	"payee.addl_st_to_whold": number;
	"payee.addl_st_to_whold_c": string;
	"payee.addl_st_to_whold_d": Date;
	"payee.addl_st_to_whold_n": number;
	"payee.addl_st_to_whold_r": number;
	"payee.address1": string;
	"payee.address2": string;
	"payee.adp_co_code": string;
	"payee.adp_e_no": string;
	"payee.birth_date": Date;
	"payee.check_address": string;
	"payee.check_address2": string;
	"payee.check_city": string;
	"payee.check_city_st_zip": string;
	"payee.check_date": Date;
	"payee.check_name": string;
	"payee.check_number": string;
	"payee.check_st": string;
	"payee.check_stub_comment": string;
	"payee.check_zip": string;
	"payee.city": string;
	"payee.city_amt_to_whold": number;
	"payee.city_amt_to_whold_c": string;
	"payee.city_amt_to_whold_d": Date;
	"payee.city_amt_to_whold_n": number;
	"payee.city_amt_to_whold_r": number;
	"payee.city_exemptions": number;
	"payee.city_tax_code": string;
	"payee.company_id": string;
	"payee.country_id": string;
	"payee.county_amt_to_whold": number;
	"payee.county_amt_to_whold_c": string;
	"payee.county_amt_to_whold_d": Date;
	"payee.county_amt_to_whold_n": number;
	"payee.county_amt_to_whold_r": number;
	"payee.county_exemptions": number;
	"payee.county_tax_code": string;
	"payee.currency": string;
	"payee.dependents": number;
	"payee.dependents_c": string;
	"payee.dependents_d": Date;
	"payee.dependents_n": number;
	"payee.dependents_r": number;
	"payee.disable_payroll_taxes": string;
	"payee.eft_first_name": string;
	"payee.eft_individual": string;
	"payee.eft_last_name": string;
	"payee.eft_middle_initial": string;
	"payee.email": string;
	"payee.email_summary": string;
	"payee.enable_carrier_app": string;
	"payee.exempt_from_fed": string;
	"payee.exempt_from_state": string;
	"payee.extra_withholdings": number;
	"payee.extra_withholdings_c": string;
	"payee.extra_withholdings_d": Date;
	"payee.extra_withholdings_n": number;
	"payee.extra_withholdings_r": number;
	"payee.fed_amt_to_whold": number;
	"payee.fed_amt_to_whold_c": string;
	"payee.fed_amt_to_whold_d": Date;
	"payee.fed_amt_to_whold_n": number;
	"payee.fed_amt_to_whold_r": number;
	"payee.fed_exemptions": number;
	"payee.fed_marital_status": string;
	"payee.freeze_by": string;
	"payee.freeze_pay": string;
	"payee.freight_matching_override": string;
	"payee.gp_exclude": string;
	"payee.gp_exported": Date;
	"payee.gp_imported": Date;
	"payee.hire_date": Date;
	"payee.holiday_hours_pd": number;
	"payee.id": string;
	"payee.last_raise_date": Date;
	"payee.legal_name": string;
	"payee.load_booking_eligible": string;
	"payee.loadpay_contact_phone": string;
	"payee.multiple_jobs": string;
	"payee.name": string;
	"payee.non_office_emp": string;
	"payee.office_employee": string;
	"payee.other_deductions": number;
	"payee.other_deductions_c": string;
	"payee.other_deductions_d": Date;
	"payee.other_deductions_n": number;
	"payee.other_deductions_r": number;
	"payee.other_income": number;
	"payee.other_income_c": string;
	"payee.other_income_d": Date;
	"payee.other_income_n": number;
	"payee.other_income_r": number;
	"payee.overtime_hours_pd": number;
	"payee.payment_method": string;
	"payee.phone_number": string;
	"payee.posted_check_date": Date;
	"payee.prev_code": string;
	"payee.primary_agency": string;
	"payee.regular_hours_pd": number;
	"payee.remarks": string;
	"payee.settlement_status": string;
	"payee.sick_hours_pd": number;
	"payee.social_security_no": string;
	"payee.st_amt_to_whold": number;
	"payee.st_amt_to_whold_c": string;
	"payee.st_amt_to_whold_d": Date;
	"payee.st_amt_to_whold_n": number;
	"payee.st_amt_to_whold_r": number;
	"payee.st_marital_status": string;
	"payee.state": string;
	"payee.state_exemptions": number;
	"payee.state_tax_code": string;
	"payee.status": string;
	"payee.sui_tax_code": string;
	"payee.tax_table_city_aux": number;
	"payee.tax_table_city_misc": number;
	"payee.tax_table_county_aux": number;
	"payee.tax_table_county_misc": number;
	"payee.tax_table_fit_aux": number;
	"payee.tax_table_fit_misc": number;
	"payee.tax_table_st_aux": number;
	"payee.tax_table_st_misc": number;
	"payee.tax_table_sui_aux": number;
	"payee.tax_table_sui_misc": number;
	"payee.termination_date": Date;
	"payee.vacation_hours_pd": number;
	"payee.vm_part_update": string;
	"payee.w4_status": string;
	"payee.wf_queue": number;
	"payee.ytd_holiday_hrs": number;
	"payee.ytd_overtime_hrs": number;
	"payee.ytd_reg_hrs_paid": number;
	"payee.ytd_sick_hrs_paid": number;
	"payee.ytd_vacation_hrs": number;
	"payee.zip_code": string;
	pending_carrier_city: string;
	pending_carrier_name: string;
	pending_carrier_nbr: string;
	pending_carrier_phone: string;
	pending_carrier_state: string;
	pending_carrier_type: string;
	pending_carrier_zip: string;
	pending_invite_conf: string;
	pending_payee_id: string;
	placard_required: string;
	preassign_sequence: number;
	priority: string;
	pro_nbr: string;
	rate_alert_basis: string;
	rate_alert_date: Date;
	rate_alert_days: number;
	rate_alert_hours: number;
	rate_alert_minutes: number;
	rate_confirm_template: number;
	rate_confirmation_sent_date: Date;
	rate_confirmation_status: string;
	rate_expiration_basis: string;
	rate_expiration_date: Date;
	rate_expiration_days: number;
	rate_expiration_hours: number;
	rate_expiration_minutes: number;
	rdy_pickup_date: Date;
	recurring_movement_id: string;
	reminder_sent: string;
	require_tracking: string;
	required_vendor: string;
	reserved: string;
	return_date: Date;
	seg_alloc_code: string;
	shipper_email: string;
	shipper_notify_frequency: string;
	shpmt_ident_type: string;
	shpmt_ident_value: string;
	ss_location_id: string;
	status: string;
	"stop_dest.actual_arrival": Date;
	"stop_dest.actual_departure": Date;
	"stop_dest.address": string;
	"stop_dest.address2": string;
	"stop_dest.appointment_status_id": string;
	"stop_dest.appt_contact_name": string;
	"stop_dest.appt_required": string;
	"stop_dest.cases": number;
	"stop_dest.city_id": number;
	"stop_dest.city_name": string;
	"stop_dest.company_id": string;
	"stop_dest.confirmed": string;
	"stop_dest.contact_email": string;
	"stop_dest.contact_name": string;
	"stop_dest.dist_from_prev": number;
	"stop_dest.dist_from_prev_um": string;
	"stop_dest.driver_load_unload": string;
	"stop_dest.edi_code": string;
	"stop_dest.edi_loc_code": string;
	"stop_dest.eta": Date;
	"stop_dest.eta_distance": number;
	"stop_dest.eta_late": string;
	"stop_dest.eta_oor": string;
	"stop_dest.google_place_id": string;
	"stop_dest.grouped_id": number;
	"stop_dest.hub": number;
	"stop_dest.ic_stop_id": string;
	"stop_dest.id": string;
	"stop_dest.inbound_status": string;
	"stop_dest.late_eta_colorcode": string;
	"stop_dest.late_route_status": string;
	"stop_dest.latitude": number;
	"stop_dest.location_id": string;
	"stop_dest.location_name": string;
	"stop_dest.longitude": number;
	"stop_dest.manifest_fgp_uid": number;
	"stop_dest.manifest_reg_uid": number;
	"stop_dest.move_dist_from_preassign": number;
	"stop_dest.move_dist_from_preassign_um": string;
	"stop_dest.move_dist_from_previous": number;
	"stop_dest.move_dist_from_previous_um": string;
	"stop_dest.movement_id": string;
	"stop_dest.movement_sequence": number;
	"stop_dest.operational_status": string;
	"stop_dest.order_id": string;
	"stop_dest.order_sequence": number;
	"stop_dest.orig_sched_early": Date;
	"stop_dest.orig_sched_late": Date;
	"stop_dest.pallets_dropped": number;
	"stop_dest.pallets_picked_up": number;
	"stop_dest.payment_code_reviewed": string;
	"stop_dest.phone": string;
	"stop_dest.planned_arrival_time": Date;
	"stop_dest.ponum": string;
	"stop_dest.prior_uncleared_stops": string;
	"stop_dest.projected_arrival": Date;
	"stop_dest.pu_override_arrive_early": Date;
	"stop_dest.pu_override_arrive_late": Date;
	"stop_dest.rate_dist_from_previous": number;
	"stop_dest.rate_dist_from_previous_um": string;
	"stop_dest.refno": string;
	"stop_dest.requested_service": string;
	"stop_dest.sched_arrive_early": Date;
	"stop_dest.sched_arrive_late": Date;
	"stop_dest.seal": string;
	"stop_dest.service_date": Date;
	"stop_dest.showas_address": string;
	"stop_dest.showas_address2": string;
	"stop_dest.showas_city_id": number;
	"stop_dest.showas_city_name": string;
	"stop_dest.showas_location_id": string;
	"stop_dest.showas_location_name": string;
	"stop_dest.showas_state": string;
	"stop_dest.showas_zip_code": string;
	"stop_dest.signed_for_name": string;
	"stop_dest.state": string;
	"stop_dest.status": string;
	"stop_dest.stop_type": string;
	"stop_dest.trimble_place_id": string;
	"stop_dest.txl_uid": number;
	"stop_dest.volume": number;
	"stop_dest.volume_um": string;
	"stop_dest.weight": number;
	"stop_dest.weight_um": string;
	"stop_dest.zip_code": string;
	"stop_dest.zone_id": string;
	"stop_origin.actual_arrival": Date;
	"stop_origin.actual_departure": Date;
	"stop_origin.address": string;
	"stop_origin.address2": string;
	"stop_origin.appointment_status_id": string;
	"stop_origin.appt_contact_name": string;
	"stop_origin.appt_required": string;
	"stop_origin.cases": number;
	"stop_origin.city_id": number;
	"stop_origin.city_name": string;
	"stop_origin.company_id": string;
	"stop_origin.confirmed": string;
	"stop_origin.contact_email": string;
	"stop_origin.contact_name": string;
	"stop_origin.dist_from_prev": number;
	"stop_origin.dist_from_prev_um": string;
	"stop_origin.driver_load_unload": string;
	"stop_origin.edi_code": string;
	"stop_origin.edi_loc_code": string;
	"stop_origin.eta": Date;
	"stop_origin.eta_distance": number;
	"stop_origin.eta_late": string;
	"stop_origin.eta_oor": string;
	"stop_origin.google_place_id": string;
	"stop_origin.grouped_id": number;
	"stop_origin.hub": number;
	"stop_origin.ic_stop_id": string;
	"stop_origin.id": string;
	"stop_origin.inbound_status": string;
	"stop_origin.late_eta_colorcode": string;
	"stop_origin.late_route_status": string;
	"stop_origin.latitude": number;
	"stop_origin.location_id": string;
	"stop_origin.location_name": string;
	"stop_origin.longitude": number;
	"stop_origin.manifest_fgp_uid": number;
	"stop_origin.manifest_reg_uid": number;
	"stop_origin.move_dist_from_preassign": number;
	"stop_origin.move_dist_from_preassign_um": string;
	"stop_origin.move_dist_from_previous": number;
	"stop_origin.move_dist_from_previous_um": string;
	"stop_origin.movement_id": string;
	"stop_origin.movement_sequence": number;
	"stop_origin.operational_status": string;
	"stop_origin.order_id": string;
	"stop_origin.order_sequence": number;
	"stop_origin.orig_sched_early": Date;
	"stop_origin.orig_sched_late": Date;
	"stop_origin.pallets_dropped": number;
	"stop_origin.pallets_picked_up": number;
	"stop_origin.payment_code_reviewed": string;
	"stop_origin.phone": string;
	"stop_origin.planned_arrival_time": Date;
	"stop_origin.ponum": string;
	"stop_origin.prior_uncleared_stops": string;
	"stop_origin.projected_arrival": Date;
	"stop_origin.pu_override_arrive_early": Date;
	"stop_origin.pu_override_arrive_late": Date;
	"stop_origin.rate_dist_from_previous": number;
	"stop_origin.rate_dist_from_previous_um": string;
	"stop_origin.refno": string;
	"stop_origin.requested_service": string;
	"stop_origin.sched_arrive_early": Date;
	"stop_origin.sched_arrive_late": Date;
	"stop_origin.seal": string;
	"stop_origin.service_date": Date;
	"stop_origin.showas_address": string;
	"stop_origin.showas_address2": string;
	"stop_origin.showas_city_id": number;
	"stop_origin.showas_city_name": string;
	"stop_origin.showas_location_id": string;
	"stop_origin.showas_location_name": string;
	"stop_origin.showas_state": string;
	"stop_origin.showas_zip_code": string;
	"stop_origin.signed_for_name": string;
	"stop_origin.state": string;
	"stop_origin.status": string;
	"stop_origin.stop_type": string;
	"stop_origin.trimble_place_id": string;
	"stop_origin.txl_uid": number;
	"stop_origin.volume": number;
	"stop_origin.volume_um": string;
	"stop_origin.weight": number;
	"stop_origin.weight_um": string;
	"stop_origin.zip_code": string;
	"stop_origin.zone_id": string;
	target_extra_stop_pay: number;
	target_extra_stop_pay_c: string;
	target_extra_stop_pay_d: Date;
	target_extra_stop_pay_n: number;
	target_extra_stop_pay_r: number;
	target_fuel_surcharge_pay: string;
	target_pay: number;
	target_pay_c: string;
	target_pay_d: Date;
	target_pay_method: string;
	target_pay_n: number;
	target_pay_r: number;
	target_pay_units: number;
	target_rate_data: string;
	target_rate_id: number;
	time_to_send_msg: Date;
	track_start_date: Date;
	tracking_duration_ext: number;
	tracking_notify_email: string;
	tracking_request_status: string;
	trailer_rent_pct: number;
	trip_lease: string;
	trip_mgt_recalc_datetime: Date;
	trip_mgt_tracking_id: string;
	triumphpay_exclude: string;
	trp_uid: number;
	ts_borrowing_company: string;
	ts_commodity: string;
	ts_movement_id: string;
	unlock_time: Date;
	waterfall_flood_time: Date;
	waterfall_in_progress: string;
	xfer2settle_date: Date;
	xferred2fueltax: string;
	xferred2fueltaxdt: Date;
	xmit_accepted: string;
	xmitted2driver: Date;
	zmit_trip: string;
}

